import type { PDFViewerStyles } from "../../types";
import type { SxProps, Theme } from "@mui/material";

const getStyles = (): Record<PDFViewerStyles, SxProps<Theme>> => {
  return {
    wrapper: {
      position: "relative",
      display: "flex",
      justifyContent: "center",
      backgroundColor: "white",
      overflow: "scroll",
      maxWidth: "100%",
      height: "100%",
      maxHeight: "100%",
    },

    close: {
      position: "fixed",
      top: 0,
      left: 0,
    },
  };
};

export default getStyles;
